export { default } from './category-post-card';
